import React from 'react';
import PropTypes from 'prop-types';
import { ICON } from '../../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

export const getCharById = id =>
    id >= 0 && id < 26 ? String.fromCharCode(id + 'A'.charCodeAt(0)) : '';

const getStudentAnswerClassName = isAnswerCorrect =>
    `highlight${isAnswerCorrect ? '' : ' without-icon'}`;

const QuestionItem = ({ sequenceNumber, isCorrect, questionText, answers }) => (
    <>
        <p className="question">
            <strong>{`Question ${sequenceNumber}: ${isCorrect ? 'correct' : 'incorrect'}`}</strong>
            <br />
            {questionText}
            <br />
        </p>
        <ol>
            {answers.map(({ id, isStudentAnswer, text, isCorrect: isCorrectAnswer }) => (
                <li
                    data-test-id="tro-answer"
                    key={generateReactKey(id)}
                    className={isStudentAnswer ? getStudentAnswerClassName(isCorrectAnswer) : null}
                >
                    {`${getCharById(id)}. `}
                    {text}
                    {isCorrectAnswer && ICON.DONE}
                </li>
            ))}
        </ol>
        <p />
    </>
);

QuestionItem.defaultProps = {
    isCorrect: false,
    questionText: null,
    answers: [],
};

QuestionItem.propTypes = {
    sequenceNumber: PropTypes.number.isRequired,
    isCorrect: PropTypes.bool,
    questionText: PropTypes.string,
    answers: PropTypes.arrayOf(PropTypes.object),
};

export default QuestionItem;
